import React from 'react';
import { useTranslation } from 'react-i18next';

import { OrderStatus } from 'enums';
import { TranslationNamespace } from 'i18n';

import { ROSA_ONE_PALETTE } from '../../constants/rosa-one-palette.constant';

const SberLogo: React.FC = () => (
  <div className="tw-grid tw-w-[42px] tw-h-[42px] tw-shrink-0 tw-rounded-[14px] tw-border tw-border-[rgba(55,235,160,.35)] tw-bg-[rgba(55,235,160,.1)]">
    <div className="tw-m-auto tw-w-[17px] tw-h-[9px] tw-border-b-[3px] tw-border-l-[3px] tw-border-solid tw-border-[#37eba0] tw-rotate-[-45deg]" />
  </div>
);

const StatusDot: React.FC<{ status?: OrderStatus }> = ({ status }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.rosa_one',
  });

  if (!status || status !== OrderStatus.CustomerConfirm) {
    return null;
  }

  return (
    <span className="tw-flex tw-gap-[6px] tw-items-center tw-text-[#adc1cf] tw-text-[11px] tw-font-bold">
      <span className="tw-inline-block tw-w-[7px] tw-h-[7px] tw-rounded-full tw-bg-[#37eba0] tw-shadow-[0_0_12px_#25d18b]" />
      {t('ready_desktop')}
    </span>
  );
};

type RosaOneHeaderProps = {
  shopName: string;
  status?: OrderStatus;
};

export const RosaOneHeader: React.FC<RosaOneHeaderProps> = ({
  shopName,
  status,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.rosa_one',
  });

  return (
    <header className="tw-flex tw-gap-3 md:tw-mb-8 tw-mb-2 tw-items-center tw-w-full">
      <SberLogo />
      <div className="tw-flex-1">
        <small
          style={{ color: ROSA_ONE_PALETTE.bright }}
          className="tw-block tw-text-[10px] tw-font-extrabold tw-tracking-[0.13em] tw-uppercase"
        >
          {`${t('gateway_label')} - ${shopName}`}
        </small>
        <strong
          style={{ color: ROSA_ONE_PALETTE.text }}
          className="tw-block tw-mt-[3px] tw-text-[15px]"
        >
          {t('payment_method')}
        </strong>
      </div>
      <StatusDot status={status} />
    </header>
  );
};
